import React from 'react'
import { DataGridPro } from '@mui/x-data-grid-pro';
import CustomToolbar from '../../datagrid/CustomToolbar';
import CustomLoadingOverlay from '../../datagrid/CustomLoadingOverlay';


const ProjectList = ({
    apiRef,
    columns,
    rows,
    error,
    loading,
    handleRowClick
}) => {
    const [pageSize, setPageSize] = React.useState(20);
    return (
        <div style={{ display: 'flex', height: '500px' }}>
            <div style={{ flexGrow: 1 }}>
                <DataGridPro
                    apiRef={apiRef}
                    rows={rows ? rows : []}
                    columns={columns}
                    loading={loading}
                    components={{
                        Toolbar: CustomToolbar,
                        LoadingOverlay: CustomLoadingOverlay,
                    }}
                    componentsProps={{
                        toolbar: { fileName: '프로젝트 리스트' },
                    }}
                    onRowClick={handleRowClick}
                    pageSize={pageSize}
                    onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                    rowsPerPageOptions={[5, 10, 20, 50, 100]}
                    pagination
                />
            </div>
        </div>
    )
}

export default ProjectList